import React, { useState, useImperativeHandle, forwardRef } from 'react'
import {
  Popper,
  Paper,
  Box,
  TextField,
  IconButton,
  Button,
  ClickAwayListener,
  Typography,
  InputAdornment,
  Popover,
} from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import { forceNumber } from '@util/helper'

const PriceEditor = forwardRef((props, ref) => {
  const [anchorEl, set_anchorEl] = useState(null)
  const [price, set_price] = useState(0)
  const [onSave, set_onSave] = useState(null)

  useImperativeHandle(ref, () => ({
    open: (event, price, onSaveFunc) => {
      set_anchorEl(event.currentTarget)
      set_price(price)
      set_onSave(() => onSaveFunc)
     
    }
  }))

  const handleClick = (event) => {
    set_anchorEl(anchorEl ? null : event.currentTarget)
  }

  const handleClose = () => {
    set_anchorEl(null)
  }

  const handleSave = () => {
    if(onSave) {
      onSave(price)
    }
    
    handleClose()
  }

  const open = Boolean(anchorEl)
  const id = open ? 'price-popper' : undefined

  return (
    <Box>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose} // ClickAwayListener 대신 사용
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        
        PaperProps={{
          sx: {
            p: 2,
            mt: 0.5, // 앵커와의 간격 미세 조정
            // border: '1px solid',
            // borderColor: 'divider',
            borderRadius: 1
          }
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 160 }}>
          <Typography variant="subtitle2" fontWeight="bold">금액 수정</Typography>
          <TextField
            size="small"
            sx={{
              width: '100%',
              // 폰트 크기 조절 (기본은 보통 16px나 14px임)
              '& .MuiInputBase-input': {
                padding: '4px 6px',    // 상하좌우 여백을 줄여 전체 높이 축소
                textAlign: 'right'
              },
            }}
            value={price}
            onChange={(e) => {
              const v = forceNumber(e.target.value)
              set_price(v)
            }}
            autoFocus
            // onKeyDown={(e) => e.key === 'Enter' && handleSave()}
          />
          <Box sx={{ display: 'flex', justifyContent: 'center', aliginItems:'center', gap: 1 }}>
            <Button size="small" onClick={handleClose}>취소</Button>
            <Button size="small" variant="contained" onClick={handleSave}>저장</Button>
          </Box>
        </Box>
      </Popover>
    </Box>
  )
})

export default PriceEditor